var currentFocusInstance;
export var setFocusTrapInstance = function setFocusTrapInstance(ref) {
  if (ref) {
    currentFocusInstance = ref.focusTrap;
  }
};
export var focusTrapActivate = function focusTrapActivate() {
  if (currentFocusInstance) {
    currentFocusInstance.activate();
  }
};
export var focusTrapDeactivate = function focusTrapDeactivate() {
  if (currentFocusInstance) {
    currentFocusInstance.deactivate({
      onDeactivate: function onDeactivate() {
        return null;
      },
      onPostDeactivate: function onPostDeactivate() {
        return null;
      }
    });
  }
};